import { useEffect } from "react";

import useScrollOverflowDetection from "hooks/useScrollOverflowDetection";

const useMainNavigationScrollDetection = () => {
  const { scrollContainerRef, canScrollUp, canScrollDown, checkScrollPosition } =
    useScrollOverflowDetection();

  useEffect(() => {
    const element = scrollContainerRef.current;
    if (!element) return;

    const handleClick = () => {
      requestAnimationFrame(checkScrollPosition);
      setTimeout(checkScrollPosition, 300);
    };
    element.addEventListener("click", handleClick, { passive: true, capture: true });

    const mutationObserver = new MutationObserver(checkScrollPosition);
    mutationObserver.observe(element, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-expanded", "data-expanded", "open"],
    });

    return () => {
      element.removeEventListener("click", handleClick);
      mutationObserver.disconnect();
    };
  }, [scrollContainerRef, checkScrollPosition]);

  return {
    scrollContainerRef,
    canScrollUp,
    canScrollDown,
  };
};

export default useMainNavigationScrollDetection;
